<app-fp-navbar/>

<!--about-->
<br><br>
<div class="breadcrumb-sec">
    <div class="container">
        <div class="flex justify-between items-center">
            <h4 class="w-50 !mb-0">
                About Us
            </h4>
            <ol class="breadcrumb m-0">
                <li class="breadcrumb-item inline-block relative">
                    <a [routerLink]="homeRoute" class="inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500">
                        <i class="material-symbols-outlined pr-2">
                            home
                        </i>
                        Home
                    </a>
                </li>
                
                <li class="breadcrumb-item inline-block relative">
                    <a [routerLink]="homeRoute" class="inline-block relative rtl:pr-[22px] transition-all hover:text-primary-500">
                        
                        About Us
                    </a>
                </li>
                
                <!-- <li class="breadcrumb-item">
                    Center Entry
                </li> -->
            </ol>
        </div>
    </div>
</div>


<div class="about-content">
    <div class="container">
        <div class="abt-cont grid grid-cols-3 gap-6">
            <div class="col-span-2">
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.</p>
            </div>
            <div>
                <img src="../../../../../assets/images/banner-1.jpg" alt="" class="image-sec">
            </div>
        </div>
    </div>
</div>


<div class="about-content" style="background-color: #efefefdd;">
    <div class="container">
        <div class="abt-cont grid grid-cols-3 gap-6">
            <div>
                <img src="../../../../../assets/images/banner-2.jpg" alt="" class="image-sec">
            </div>
            <div class="col-span-2">
                <h6>Our Mission & Vision</h6>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.</p>
            </div>
            
        </div>
    </div>
</div>


<app-fp-footer/>
